import cadastrosRoutes from "./pages/cadastros";
import notificacaoRoutes from "./pages/notificacao";
import clientStatusRoutes from "./pages/clients";
import tasksRoutes from "./pages/task";
import logRoutes from "./pages/log";
import changeLog from "./pages/changelog";
import testerRouter from "./pages/tester";
import contratosRouter from "./pages/contratos";
import programacaoAgendaRouter from "./pages/programacao";
import fluxosRoutes from "./pages/fluxos";
import processosRoutes from "./pages/processos";
import secretsManagerContentRoutes from "./pages/SecretsManager";
import mattermostContentRoutes from "./pages/mattermost";
import infraContentRoutes from "./pages/infra";
import financeiroRouters from "./pages/financeiro";
import {sprints_content_routes} from "./pages/dashboard/sprints";
import {matchPath} from "react-router-dom";
import {ContentRoute} from "./models/Route";

// Registro das paginas que o frontend sabe montar (path -> componente).
// Quem ve o que e decidido no backend, pelo config/acesso.yaml e pelos perfis
// (#484909): o menu e a guarda das paginas vem de la. Os campos de grupo
// abaixo (description, icon, to) so servem para a breadcrumb.


var menus = [
    {
        'name': 'tasks',
        'description': 'Projetos',
        'icon': 'cil-task',
        'children': tasksRoutes,
        'only_root': true,
        'to': '/task'
    },
    {
        'name': 'Programação',
        'description': 'Programação ',
        'icon': 'cil-calendar',
        'children': programacaoAgendaRouter,
        'only_root': true,
        'to': '/programacao'
    },
    {
        'name': 'processos',
        'description': 'Processos',
        'icon': 'cil-task',
        'children': processosRoutes,
        'only_root': true,
        'to': '/processos'
    },
    {
        'name': 'fluxos',
        'description': 'Fluxos',
        'icon': 'cil-list-numbered',
        'children': fluxosRoutes,
        'only_root': true,
        'to': '/fluxos'
    },
    {
        'name': 'cadastros',
        'description': 'Cadastros',
        'icon': 'cil-puzzle',
        'children': cadastrosRoutes
    },
    {
        'name': 'notificacao',
        'description': 'Notificações',
        'icon': 'cil-speech',
        'children': notificacaoRoutes,
        'only_root': true,
        'to': '/notificacao'
    },
    {
        'name': 'client_status',
        'description': 'Status de Clientes',
        'icon': 'cil-info',
        'children': clientStatusRoutes,
        'only_root': true,
        'to': '/client-status'
    },
    {
        'name': 'logs',
        'description': 'Logs de Clientes',
        'icon': 'cil-code',
        'children': logRoutes,
        'only_root': true,
        'to': '/log'
    },
    {
        'name': 'changelog',
        'description': 'Change Log',
        'icon': 'cil-calendar',
        'children': changeLog,
        'only_root': true,
        'to': '/changelog'
    },
    {
        'name': 'panoverseQa',
        'description': 'Panoverse - QA',
        'icon': 'cil-code',
        'children': testerRouter,
        'to': '/panoverseQa'
    },
    {
        'name': 'Comercial',
        'description': 'Comercial ',
        'icon': 'cilPeople',
        'children': contratosRouter,
        'to': '/contratos'
    },
    {
        'name': 'secretsManager',
        'description': 'Secrets Manager',
        'icon': 'cil-lock-locked',
        'children': secretsManagerContentRoutes,
        'only_root': true,
        'to': '/secrets-manager'
    },
    {
        'name': 'infra',
        'description': 'Central de Infra',
        'icon': 'cil-drop',
        'children': infraContentRoutes,
        'only_root': true,
        'to': '/infra',
    },
    {
        'name': 'mattermost',
        'description': 'Mattermost',
        'icon': 'cil-speech',
        'children': mattermostContentRoutes,
        'only_root': true,
        'to': '/mattermost'
    },
    {
        'name': 'financeiro',
        'description': 'Financeiro',
        'icon': 'cil-dollar',
        'children': financeiroRouters
    },
    {
        'name': 'dashboard_developers',
        'description': 'Manager Development',
        'icon': 'cilSpeedometer',
        'children': sprints_content_routes,
        'to': '/dashboard'
    },
];
export const contentRoutes = menus;

/** Todas as paginas registradas, de todos os grupos. */
export const todasAsPaginas: ContentRoute[] = menus.reduce(
    (paginas: ContentRoute[], grupo: any) => paginas.concat(grupo.children),
    []
);

/** Pagina registrada que atende este caminho, como o Switch do content faria. */
export const paginaDoCaminho = (caminho: string): ContentRoute | undefined => {
    return todasAsPaginas.find(pagina => matchPath(caminho, {path: pagina.path, exact: pagina.exact}));
};
